interface IconProps {
  className?: string
}

const iconBase = "w-16 h-16 sm:w-20 sm:h-20"

export function RegisterIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="50" cy="50" r="46" fill="white" opacity="0.15" />
      {/* Person */}
      <circle cx="50" cy="35" r="10" fill="white" />
      <path d="M35 58 C35 48, 42 42, 50 42 C58 42, 65 48, 65 58" fill="white" />
      {/* Plus */}
      <circle cx="70" cy="35" r="9" fill="#5E9732" />
      <line x1="70" y1="30" x2="70" y2="40" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <line x1="65" y1="35" x2="75" y2="35" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export function BrowseIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="50" cy="50" r="46" fill="white" opacity="0.15" />
      {/* Grid of cards */}
      <rect x="25" y="28" width="22" height="18" rx="2" fill="white" />
      <rect x="53" y="28" width="22" height="18" rx="2" fill="white" />
      <rect x="25" y="52" width="22" height="18" rx="2" fill="white" />
      <rect x="53" y="52" width="22" height="18" rx="2" fill="white" opacity="0.6" />
      {/* Search */}
      <circle cx="72" cy="25" r="7" fill="#5E9732" />
      <circle cx="71" cy="24" r="3.5" stroke="white" strokeWidth="1.2" fill="none" />
      <line x1="73.5" y1="26.5" x2="76" y2="29" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  )
}

export function EnrollIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="50" cy="50" r="46" fill="white" opacity="0.15" />
      {/* Clipboard */}
      <rect x="32" y="25" width="36" height="48" rx="3" fill="white" />
      <rect x="42" y="22" width="16" height="8" rx="3" fill="#D6E8F2" />
      {/* Checkboxes */}
      <rect x="38" y="38" width="7" height="7" rx="1" fill="#5E9732" />
      <path d="M40 42 L41.5 43.5 L44 40" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="48" y="39" width="14" height="3" rx="1" fill="#C0C2C4" />
      <rect x="38" y="50" width="7" height="7" rx="1" fill="#5E9732" />
      <path d="M40 54 L41.5 55.5 L44 52" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="48" y="51" width="14" height="3" rx="1" fill="#C0C2C4" />
      <rect x="38" y="62" width="7" height="7" rx="1" stroke="#C0C2C4" strokeWidth="1" fill="none" />
      <rect x="48" y="63" width="14" height="3" rx="1" fill="#C0C2C4" />
    </svg>
  )
}

export function LearnIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="50" cy="50" r="46" fill="white" opacity="0.15" />
      {/* Graduation cap */}
      <path d="M25 48 L50 35 L75 48 L50 58 Z" fill="white" />
      <line x1="50" y1="58" x2="50" y2="72" stroke="white" strokeWidth="2" />
      <path d="M62 52 L62 64 C62 68, 50 72, 50 72 C50 72, 38 68, 38 64 L38 52" fill="white" opacity="0.4" />
      {/* Tassel */}
      <line x1="75" y1="48" x2="75" y2="62" stroke="#FFBE2E" strokeWidth="2" strokeLinecap="round" />
      <circle cx="75" cy="64" r="3" fill="#FFBE2E" />
    </svg>
  )
}

export function CompleteIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="50" cy="50" r="46" fill="white" opacity="0.15" />
      {/* Certificate */}
      <rect x="28" y="28" width="44" height="35" rx="3" fill="white" />
      <rect x="35" y="34" width="30" height="3" rx="1.5" fill="#003a5c" />
      <rect x="38" y="41" width="24" height="2" rx="1" fill="#C0C2C4" />
      <rect x="40" y="47" width="20" height="2" rx="1" fill="#C0C2C4" />
      {/* Seal */}
      <circle cx="50" cy="68" r="12" fill="#5E9732" />
      <path d="M44 68 L48 72 L56 64" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  )
}

export function FeedbackStepIcon({ className = iconBase }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <circle cx="50" cy="50" r="46" fill="white" opacity="0.15" />
      {/* Star */}
      <polygon
        points="50,22 56,40 75,40 60,51 65,69 50,58 35,69 40,51 25,40 44,40"
        fill="white"
      />
      {/* Small stars */}
      <polygon
        points="28,28 30,33 35,33 31,36 32,41 28,38 24,41 25,36 21,33 26,33"
        fill="white" opacity="0.5"
      />
      <polygon
        points="72,28 74,33 79,33 75,36 76,41 72,38 68,41 69,36 65,33 70,33"
        fill="white" opacity="0.5"
      />
    </svg>
  )
}
